import * as general from '@/utils/mixins/general'
import { lazyLoadModal } from '@/utils/mixins/lazy-load-modal'
import refDimensions from '@/utils/mixins/ref-dimensions'
import cmp from '~/utils/mixins/cmp'
import cmpEventsListener from '~/utils/mixins/cmp-events-listener'
import { captchaLazyLoad } from '@/utils/mixins/captcha-lazy-load'
import { countryInfo } from '@/utils/mixins/country-info'

export default {
  ...general,
  lazyLoadModal,
  refDimensions,
  cmp,
  cmpEventsListener,
  captchaLazyLoad,
  countryInfo
}
